function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modifier from 'ember-modifier';
import { throttle } from '@ember/runloop';
const SCROLL_THROTTLE_DURATION = 1000;
export default class BankingOnScrollToBottom extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "lastKnownPosition", -1);
    _defineProperty(this, "onScroll", void 0);
    _defineProperty(this, "callback", void 0);
  }
  install() {
    const currentPosition = window.innerHeight + window.scrollY;
    const pageBottom = document.body.offsetHeight;
    // Only call callback if we are hitting bottom of the page for the first time
    // Without this logic, callback will get called many times because the scroll
    // events emit in bursts
    if (this.lastKnownPosition < pageBottom && currentPosition >= pageBottom) {
      // Do not call callback more than 1x per second
      throttle(this.callback, SCROLL_THROTTLE_DURATION);
    }
    this.lastKnownPosition = currentPosition;
  }
  didInstall() {
    this.callback = this.args.positional[0];
    this.onScroll = () => {
      this.install();
    };
    window.addEventListener('scroll', this.onScroll);
  }
  willDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}